<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35" style="display: flex;flex-wrap: wrap;">

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" class="mb20">
            <el-form-item label="统计日期">
              <el-date-picker @change="handTime" style="width: 100%" v-model="createdate" type="daterange" align="right"
                unlink-panels start-placeholder="开始时间" end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" class="mb20">
            <el-form-item label="小说剧目">
              <SelectChecked :options="movieOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择剧目"
                @selectedVal="selectedMovie" :search="search" />
            </el-form-item>
          </el-col>

          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" class="mb20">
            <el-form-item label="平台类型">
              <el-select v-model="queryParams.platform_type" @change="search" style="width: 100%" placeholder="请选择平台类型">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="抖音" :value="1"></el-option>
                <el-option label="微信" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col v-if="isShowVip" :xs="24" :sm="12" :md="8" :lg="8" :xl="6" class="mb20">
            <el-form-item label="渠道">
              <SelectChecked :options="vipOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择渠道"
                @selectedVal="selectedVip" :search="search" />
            </el-form-item>
          </el-col>

          <el-col v-if="isShowOptimizer" :xs="24" :sm="12" :md="8" :lg="8" :xl="6" class="mb20">
            <el-form-item label="优化师">
              <SelectChecked :options="optimizerOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择优化师"
                @selectedVal="selectedOptimizer" :search="search" />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="6" class="mb20">
            <el-button size="medium" type="primary" :loading="loading" @click="search">查询</el-button>
            <el-button size="medium" @click="Clear">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" size="medium" border
        :header-cell-style="{ textAlign: 'right' }" :cell-style="{ textAlign: 'right' }" show-summary
        :summary-method="getSummaries" sum-text="汇总" v-loading="loading">

        <el-table-column label="日期" align=center>
          <template slot-scope="scope">{{ scope.row.createdate }}</template>
        </el-table-column>

        <el-table-column label="消耗">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="costInfo(scope.row)">
              {{ scope.row.cost }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="激活">
          <template slot-scope="scope">{{ scope.row.new_active_num }}</template>
        </el-table-column>

        <el-table-column label="今日新增充值人数">
          <template slot-scope="scope">{{ scope.row.new_recharge_user }}</template>
        </el-table-column>

        <el-table-column label="今日新增充值金额">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="medium" @click="rechargeMoneyInfo(scope.row)"> -->
            {{ scope.row.new_recharge_money }}
            <!-- </el-button> -->
          </template>
        </el-table-column>

        <el-table-column label="激活单价">
          <template slot-scope="scope">{{ scope.row.active_price }}</template>
        </el-table-column>

        <el-table-column label="付费单价">
          <template slot-scope="scope">{{ scope.row.paid_price }}</template>
        </el-table-column>

        <el-table-column label="首日付费率">
          <template slot-scope="scope">{{ scope.row.fd_paid_rate }}%</template>
        </el-table-column>

        <el-table-column label="付费完成率">
          <template slot-scope="scope">{{ scope.row.paid_complete_rate }}%</template>
        </el-table-column>

        <el-table-column label="首日ARPPU">
          <template slot-scope="scope">{{ scope.row.fd_arppu }}</template>
        </el-table-column>

        <el-table-column label="首日ROI">
          <template slot-scope="scope">
            <span v-if="scope.row.fd_roi < 100" style="color: green">{{ scope.row.fd_roi }}%</span>
            <span v-else style="color: red">{{ scope.row.fd_roi }}%</span>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getAdDataList" />

      <el-drawer :wrapperClosable="true" :title="viewTitle" :visible.sync="showCost" size="50%">
        <div class="Box">
          <el-card class="box-card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="小说榜" name="1">
                <el-table ref="multipleTable" :data="costTableData" tooltip-effect="dark" style="width: 100%"
                  size="medium" :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                  :cell-style="{ textAlign: 'center' }" border v-loading="costloading">

                  <el-table-column label="排名" width="75">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                  </el-table-column>

                  <el-table-column label="小说ID" width="125">
                    <template slot-scope="scope">{{ scope.row.movie_id }}</template>
                  </el-table-column>

                  <el-table-column prop="name" label="小说名称">
                    <template slot-scope="scope">{{ scope.row.movie_name }}</template>
                  </el-table-column>

                  <el-table-column v-if="showType == 1" prop="name" label="消耗" width="105">
                    <template slot-scope="scope">{{ scope.row.cost }}</template>
                  </el-table-column>

                  <el-table-column v-if="showType == 2" prop="name" label="今日新增充值金额">
                    <template slot-scope="scope">{{ scope.row.new_recharge_money }}</template>
                  </el-table-column>
                  <el-table-column prop="name" label="今日新增充值金额">
                    <template slot-scope="scope">{{ scope.row.new_recharge_money }}</template>
                  </el-table-column>
                  <el-table-column prop="name" label="首日ROI">
                    <template slot-scope="scope">
                      <span v-if="scope.row.roi < 100" style="color: green">{{ scope.row.roi }}%</span>
                      <span v-else style="color: red">{{ scope.row.roi }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="渠道榜" name="2">

                <el-table ref="multipleTable" :data="costTableData" tooltip-effect="dark" style="width: 100%"
                  size="medium" :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                  :cell-style="{ textAlign: 'center' }" border v-loading="costloading">

                  <el-table-column label="排名" width="75">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                  </el-table-column>

                  <el-table-column label="渠道ID" width="125">
                    <template slot-scope="scope">{{ scope.row.vip_id }}</template>
                  </el-table-column>

                  <el-table-column prop="name" label="渠道名称">
                    <template slot-scope="scope">{{ scope.row.vip_name }}</template>
                  </el-table-column>

                  <el-table-column v-if="showType == 1" prop="name" label="消耗" width="105">
                    <template slot-scope="scope">{{ scope.row.cost }}</template>
                  </el-table-column>

                  <el-table-column v-if="showType == 2" prop="name" label="今日新增充值金额">
                    <template slot-scope="scope">{{ scope.row.new_recharge_money }}</template>
                  </el-table-column>
                  <el-table-column prop="name" label="今日新增充值金额">
                    <template slot-scope="scope">{{ scope.row.new_recharge_money }}</template>
                  </el-table-column>
                  <el-table-column prop="name" label="首日ROI">
                    <template slot-scope="scope">
                      <span v-if="scope.row.roi < 100" style="color: green">{{ scope.row.roi }}%</span>
                      <span v-else style="color: red">{{ scope.row.roi }}%</span>
                    </template>
                  </el-table-column>
                </el-table>

              </el-tab-pane>

            </el-tabs>
          </el-card>
        </div>

      </el-drawer>

    </el-card>
  </div>
</template>
<script>

import { GeneralCollectApi } from '@/api/statistics/comStatistics/index';
import { adDataApi } from '@/api/statistics/adData/index';
import { processErrors } from '@/utils/errorHandler';
import SelectChecked from '@/components/Select/SelectChecked'
import { Session } from '@/utils/storage';

export default {
  components: {
    SelectChecked
  },
  data() {
    return {
      queryParams: {//查询参数
        pageNo: 1,
        pageSize: 10,
        createdate_start: '',
        createdate_end: '',
        platform_type: '',
        movie_id: '',
        vip_id: '',
        optimizer_id: '',
      },

      createdate: [],//时间区间

      tableData: [],//列表数据
      total: 0,//数据量
      totalData: [],//数据汇总

      movieOptions: [],//选择小说列表
      vipOptions: [],//选择vip列表
      optimizerOptions: [],//选择优化师列表
      referralOptions: [],//选择渠道号列表

      loading: true,//加载状态
      isRemoveAllTag: 0,//下拉框是否清空

      roleId: 1,//角色id
      isShowVip: true,//是否显示vip下拉框
      isShowOptimizer: true,//是否显示优化师下拉框

      showCost: false,
      costTableData: [],
      viewTitle: '',
      activeName: '1',
      rechargeMoney: '1',
      createdateParams: '',
      costloading: true,
      showType: '',
    };
  },

  created() {
    this.defaultTime();
    this.getRoleId();
    this.getSelectMovie();
    this.getAdDataList();
  },
  methods: {

    costInfo(info) {
      this.activeName = "1";
      this.showCost = true;
      this.createdateParams = info.createdate;
      this.viewTitle = `日期：${info.createdate}  消耗：${info.cost}`;
      this.getMovieCost();
      this.showType = 1
    },

    // rechargeMoneyInfo(info) {
    //   this.activeName = "1";
    //   this.showCost = true;
    //   this.createdateParams = info.createdate;
    //   this.viewTitle = `日期：${info.createdate}  今日新增充值金额：${info.new_recharge_money}`;
    //   this.getMovieRechargeMoney();
    //   this.showType = 2
    // },

    handleClick(tab, event) {
      if (this.showType == 1) {
        if (this.activeName == '1') {
          this.getMovieCost();
        } else {
          this.getChannelCost();
        }
      } else if (this.showType == 2) {
        if (this.activeName == '1') {
          this.getMovieRechargeMoney();
        } else {
          this.getChannelRechargeMoney();
        }
      }
    },

    //消耗-小说排行
    getMovieCost() {
      this.costTableData = [];
      this.costloading = true;
      let api = adDataApi();
      let params = {
        createdate: this.createdateParams,
        platform_type: this.queryParams.platform_type,
        movie_id: this.queryParams.movie_id,
        vip_id: this.queryParams.vip_id,
        optimizer_id: this.queryParams.optimizer_id,
      };
      api.costMovieList(params)
        .then((res) => {
          if (res.code == 0) {
            this.costTableData = res.data;
          } else {
            processErrors(res);
          }
          this.costloading = false;
        }).catch((error) => {
        });
    },

    getChannelCost() {
      this.costTableData = [];
      this.costloading = true;
      let api = adDataApi();
      let params = {
        createdate: this.createdateParams,
        platform_type: this.queryParams.platform_type,
        movie_id: this.queryParams.movie_id,
        vip_id: this.queryParams.vip_id,
        optimizer_id: this.queryParams.optimizer_id,
      };
      api.costChannelList(params)
        .then((res) => {
          if (res.code == 0) {
            this.costTableData = res.data;
          } else {
            processErrors(res);
          }
          this.costloading = false;
        })
        .catch((error) => {
        });
    },

    getChannelRechargeMoney() {
      this.costTableData = [];
      this.costloading = true;
      let api = adDataApi();
      let params = {
        createdate: this.createdateParams,
        platform_type: this.queryParams.platform_type,
        movie_id: this.queryParams.movie_id,
        vip_id: this.queryParams.vip_id,
        optimizer_id: this.queryParams.optimizer_id,
      };
      api.rechargeMoneyChannelList(params)
        .then((res) => {
          if (res.code == 0) {
            this.costTableData = res.data;
          } else {
            processErrors(res);
          }
          this.costloading = false;
        })
        .catch((error) => {
        });
    },

    //今日新增充值金额-小说排行
    getMovieRechargeMoney() {
      this.costTableData = [];
      this.costloading = true;
      let api = adDataApi();
      let params = {
        createdate: this.createdateParams,
        platform_type: this.queryParams.platform_type,
        movie_id: this.queryParams.movie_id,
        vip_id: this.queryParams.vip_id,
        optimizer_id: this.queryParams.optimizer_id,
      };
      api.rechargeMoneyMovieList(params)
        .then((res) => {
          if (res.code == 0) {
            this.costTableData = res.data;
          } else {
            processErrors(res);
          }
          this.costloading = false;
        }).catch((error) => {
        });
    },

    /**
     * 生成默认时间区间(本月一号到当天)
     */
    defaultTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      // const time = '00:00:00';
      // const times = '23:59:59';
      const formattedDate = `${year}-${month}-01`;
      const formattedDates = `${year}-${month}-${day}`;
      this.createdate = [formattedDate, formattedDates];
      this.queryParams.createdate_start = formattedDate;
      this.queryParams.createdate_end = formattedDates;
    },

    /**
     * 选择小说
     */
    selectedMovie(value) {
      this.queryParams.movie_id = value.join(',');
    },

    /**
     * 选择vip
     */
    selectedVip(value) {
      this.queryParams.vip_id = value.join(',');
    },

    /**
     * 选择优化师
     */
    selectedOptimizer(value) {
      this.queryParams.optimizer_id = value.join(',');
    },

    /**
     * 选择渠道号
     */
    selectedReferral(value) {
      this.queryParams.channel_code = value.join(',');
    },

    search() {
      this.getAdDataList();
    },

    /**
     *选择时间
     */
    handTime(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2);
      // const time = '00:00:00';
      const formattedDate = `${year}-${month}-${day}`;

      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2);
      // const times = '23:59:59';
      const formattedDates = `${years}-${months}-${days}`;

      const diffInDays = Math.floor(Math.abs((new Date(formattedDate) - new Date(formattedDates)) / (1000 * 60 * 60 * 24)));

      if (diffInDays > 90) {
        this.$message.error('检索日期最大跨度为90天');
        this.defaultTime();
      } else {
        this.createdate = [formattedDate, formattedDates];
        this.queryParams.createdate_start = formattedDate;
        this.queryParams.createdate_end = formattedDates;
      }
      this.search();
    },

    /**
     * 清空
     */
    Clear() {
      this.queryParams = {//查询参数
        pageNo: 1,
        pageSize: 10,
        createdate_start: '',
        createdate_end: '',
        platform_type: '',
        movie_id: '',
        vip_id: '',
        optimizer_id: '',
      };
      this.isRemoveAllTag += 1;
      this.defaultTime();
      this.search()
    },

    /**
     * 获取选择小说列表
     */
    getSelectMovie() {
      const api = GeneralCollectApi();
      let params = {
        pageSize: 99999,
      };
      api.getSelectMovie(params)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.data;
            this.movieOptions = data.map(item => ({
              value: item.id.toString(),
              label: item.name,
              check: false
            }));
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    /**
     * 获取选择VIP列表
     */
    getSelectVip() {
      const api = GeneralCollectApi();
      api.getSelectVip()
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.vipOptions = data.map(item => ({
              value: item.id.toString(),
              label: item.nickname,
              check: false
            }));
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    /**
     * 获取选择优化师列表
     */
    getSelectOptimizer() {
      const api = GeneralCollectApi();
      api.getSelectOptimizer()
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.optimizerOptions = data.map(item => ({
              value: item.id.toString(),
              label: item.nickname,
              check: false
            }));
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    /**
     * 获取用户角色
     */
    getRoleId() {
      this.roleId = Session.get("roleId");
      if (this.roleId == 3) {
        this.isShowVip = false;
        this.getSelectOptimizer();
      } else if (this.roleId == 4) {
        this.isShowVip = false;
        this.isShowOptimizer = false;
      } else {
        this.getSelectVip();
        this.getSelectOptimizer();
      }
    },

    /**
     * 获取综合统计列表
     */
    getAdDataList() {
      this.loading = true;
      const api = adDataApi();
      api.adDataList(this.queryParams)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.totalCount;
            this.totalData = res.data.total;
          } else {
            processErrors(res);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    /**
     * 汇总数据
     * @param param
     * @returns {*[]}
     */
    getSummaries(param) {
      const sums = [];
      sums[0] = '汇总';
      sums[1] = this.totalData.total_cost;
      sums[2] = this.totalData.total_new_active_num;
      sums[3] = this.totalData.total_new_recharge_user;
      sums[4] = this.totalData.total_new_recharge_money;
      sums[5] = this.totalData.total_active_price;
      sums[6] = this.totalData.total_paid_price;
      sums[7] = this.totalData.total_fd_paid_rate + '%';
      sums[8] = this.totalData.total_paid_complete_rate + '%';
      sums[9] = this.totalData.total_fd_arppu;
      sums[10] = this.totalData.total_fd_roi + '%';
      return sums;
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  text-align: right;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

::v-deep .el-table {
  display: flex;
  flex-direction: column;
}

/* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
::v-deep .el-table__body-wrapper {
  order: 1;
}

::v-deep .el-table__fixed-body-wrapper {
  top: 96px !important;
}

::v-deep .el-table__fixed-footer-wrapper {
  z-index: 0;
}
</style>
